import React, { useContext, memo } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { ScrollLink } from '@prisjakt/ui-scroll';
import { Link, useLocation } from 'react-router-dom';
import { RouteSection } from '../../../types';
import { ProductPageQuery } from '../../../../../types';
import { getScrollLinkOffset } from '../../../utils';
import { ReviewsTabId } from '../../product-tabs/constants';

const LinkToReviews: React.FC<ILinkToReviewsProps> = props => {
  const {
    product,
    routeSection,
    children,
    onClick,
    shouldRenderAllTabs,
  } = props;
  const location = useLocation();
  const { linkTo, t } = useContext(AppContext);
  const to = shouldRenderAllTabs
    ? `${location.pathname}${location.search}${ReviewsTabId}`
    : linkTo('productReviews', product);

  return routeSection === 'reviews' ? (
    <ScrollLink
      to="Reviews"
      calculateOffset={getScrollLinkOffset}
      onClick={onClick}
    >
      {children}
    </ScrollLink>
  ) : (
    <Link to={to} onClick={onClick} aria-label={t('product', 'tabs.reviews')}>
      {children}
    </Link>
  );
};

interface ILinkToReviewsProps {
  product: ProductPageQuery['product'];
  routeSection?: RouteSection;
  onClick?: (ev: React.MouseEvent) => void;
  children?: React.ReactNode;
  shouldRenderAllTabs: boolean;
}

export default memo(LinkToReviews);
